import { tenantIDAtom } from "atoms/GlobalAtoms";
import AppTooltip from "elements/AppTooltip";
import IconButton from "elements/IconButton";
import { useAtomValue } from "jotai";
import { Button } from "reactstrap";
import AppSpinner from "../../elements/AppSpinner";
import { useNavigate } from "react-router-dom";

const WorkflowToolbar = ({
  workflow,
  openWorkflowDrawer,
  onSave,
  saving,
  changesMade,
  cancelChanges,
  createMode,
}) => {
  const navigate = useNavigate();
  const tenantID = useAtomValue(tenantIDAtom);

  return (
    <div className="border-bottom border-superlight workflow-toolbar shadow w-100 d-flex align-items-center justify-content-between p-2">
      <div className="d-flex align-items-center">
        <IconButton
          icon="chevron-left"
          className="mr-4"
          onClick={() => navigate(`/clouds/${tenantID}/workflows`)}
        />
        <div>
          <h4 className="mb-0">{workflow?.Name}</h4>
          <small>{workflow?.Description}</small>
        </div>
      </div>
      <div className="d-flex">
        <AppTooltip
          content="Edit Workflow Name, Description, Initial Trigger"
          useTooltip
        >
          <Button
            size="sm"
            className="btn-icon-only"
            outline
            onClick={openWorkflowDrawer}
          >
            <i className="mdi mdi-pencil" />
          </Button>
        </AppTooltip>
        {!createMode && changesMade && (
          <Button size="sm" onClick={cancelChanges} className="ml-2 mr-0">
            Cancel Changes
          </Button>
        )}
        <Button
          size="sm"
          color="primary"
          onClick={onSave}
          className="mx-2"
          style={{ width: 70 }}
          disabled={saving || (!createMode && !changesMade)}
        >
          {saving ? <AppSpinner size="sm" color="white" /> : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default WorkflowToolbar;
